module.exports = __webpack_public_path__ + "img/icon-xt2.33b83292.png";